import $ from "jquery";

export function popover() {

    $(function () {
        $('[data-toggle="popover"]').popover({
            html: true
        })

    });

}